var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-table", {
        staticClass: "bordered table-no-minheight",
        attrs: {
          items: _vm.skuConfigurations,
          fields: _vm.fields,
          small: "",
          "show-empty": "",
          "empty-text": _vm.$t("Nenhuma configuração cadastrada"),
          responsive: "",
          striped: "",
        },
        scopedSlots: _vm._u([
          {
            key: "cell(actions)",
            fn: function (ref) {
              var item = ref.item
              return [
                !_vm.isReadOnly
                  ? _c("e-grid-actions", {
                      attrs: { "show-update": true, "show-delete": true },
                      on: {
                        delete: function ($event) {
                          return _vm.$emit("delete-configuration", item)
                        },
                        update: function ($event) {
                          return _vm.$emit("update-configuration", item)
                        },
                      },
                    })
                  : _vm._e(),
                item.storeId === -1 || _vm.isReadOnly
                  ? _c("span", [_vm._v("-")])
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _c(
        "b-row",
        { staticClass: "mt-2" },
        [
          _c(
            "b-col",
            { staticClass: "text-right", attrs: { md: "12" } },
            [
              !_vm.isReadOnly
                ? _c("e-button", {
                    attrs: {
                      variant: "primary",
                      icon: "plus-circle",
                      text: _vm.$t("Adicionar Estoque Mínimo"),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("add-configuration")
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }